import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../services/i18nService';

import styles from './testOverview.scss';
import securityService from '../../services/SecurityService';
import sessionReader from '../../store/readHelpers/SessionReader';
import ExitTestButton from './ExitTestButton';

class TestComponentsDoneBox extends React.Component {
    static propTypes = {
        allChildTestsFinished: PropTypes.bool.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            passwordCorrect: false,
        };
    }

    handlePasswordChange = (e) => {
        const passwordCorrect = securityService.verifyInvigilatorPassword(e.target.value);
        this.setState({ passwordCorrect });
    };

    render() {
        const { allChildTestsFinished } = this.props;
        const { passwordCorrect } = this.state;

        if (sessionReader.isRemoteOralExam()) {
            return (<div className={`${styles.actionBox} ${styles.exitBox} ${styles.current}`}>
                <p>{t('remoteOralExam.waitingRoom.testCompleted')}</p>
                <ExitTestButton showButtonForNonLockdown />
            </div>);
        }

        if (!sessionReader.testUsesInvigilatorPassword() || !sessionReader.requireTestOverViewExitInvigilatorPassword()) {
            return (
                <div className={`${styles.actionBox} ${styles.exitBox} ${styles.current}`}>
                    <p className={styles.text}>
                        { allChildTestsFinished
                            ? t('childTest.parentTestFinished')
                            : t('childTest.parentTestTimeout')
                        }
                    </p>
                    <ExitTestButton showButtonForNonLockdown />
                </div>
            );
        }

        return (
            <div className={`${styles.actionBox} ${styles.exitSEBBox} ${styles.current}`}>
                <p className={styles.text}>
                    { allChildTestsFinished
                        ? `${t('childTest.parentTestFinished')} ${t('childTest.waitForFurtherInstructions')}`
                        : `${t('childTest.parentTestTimeout')}`
                    }
                </p>
                <div className={styles.invigilatorBox}>
                    <h4>{t('childTest.continueAsInvigilator')}</h4>
                    <label htmlFor="invigilator-password-input">{t('childTest.invigilatorPassword')}</label>
                    <input
                        className={styles.passwordInput}
                        id="invigilator-password-input"
                        type="password"
                        name="invigilator-password"
                        onChange={this.handlePasswordChange}
                    />
                    <ExitTestButton disabled={!passwordCorrect} showButtonForNonLockdown />
                </div>
            </div>
        );
    }
}

export default TestComponentsDoneBox;
